"use strict";
/**
 * @module valueSetClient
 * @description  Value Set Client provides an easy way to consume Baasic Value Set REST end-points. In order to obtain needed routes `baasicValueSetService` uses `baasicValueSetRouteService`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ValueSetClient = /** @class */ (function () {
    function ValueSetClient(valueSetRoute, valueSetItemClient, apiClient) {
        this.valueSetRoute = valueSetRoute;
        this.valueSetItemClient = valueSetItemClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ValueSetClient.prototype, "items", {
        get: function () {
            return this.valueSetItemClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValueSetClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `valueSetRoute`.
         * @method
         * @example valueSetClient.routeDefinition.get().expand(expandObject);
        **/
        get: function () {
            return this.valueSetRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of value set resources matching given criteria.
     * @param options query resource options object
     * @returns A promise that is resolved once the find action has beend performed.
     * @method
     * @example valueSetClient.find({
                    pageNumber: 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified value set resource.
     * @param setName value set name
     * @param options query resource options object
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example valueSetClient.get('<value-set-name>')
                   .success(function (data) {
                       // perform success action here
                   })
                   .error(function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ValueSetClient.prototype.get = function (setName, options) {
        return this.apiClient.get(this.valueSetRoute.get(setName, options));
    };
    /**
     * Returns a promise that is resolved once the create value set action has been performed; this action creates a new value set resource.
     * @param data A key value object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create value set action has beend performed.
     * @method
     * @example valueSetClient.create({
                    name: '<value-set-name>',
                    description: '<description>',
                    values: [{value: '<value>'}]
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update value set action has been performed; this action updates a value set resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicValueSetService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSet);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data Value set object used to update specified value set resource.
     * @returns A promise that is resolved once the update value set action has been performed.
     * @method
     * @example // valueSet is a resource previously fetched using get action.
                    valueSet.name = '<new-name>';
                    valueSetClient.update(valueSet)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ValueSetClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will delete a value set resource if the action is completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `valueSetClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSet);
     * let uri = params['model'].links('delete').href;
     * ```
     * @param data A value set object used to delete specified value set resource.
     * @method
     * @example // valueSet is a resource previously fetched using get action.
                    valueSetClient.remove(valueSet)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ValueSetClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    ValueSetClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ValueSetRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ValueSetItemClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ValueSetRoute !== "undefined" && _1.ValueSetRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ValueSetItemClient !== "undefined" && _1.ValueSetItemClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ValueSetClient);
    return ValueSetClient;
}());
exports.ValueSetClient = ValueSetClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
